import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createVNode as _createVNode, KeepAlive as _KeepAlive, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-54cc1cbd")

_pushScopeId("data-v-54cc1cbd")
const _hoisted_1 = {
  class: "tabs",
  style: {"overflow-x":"hidden"}
}
const _hoisted_2 = { key: 0 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_PositionMagic = _resolveComponent("PositionMagic")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_PositionMagic, null, {
      [_ctx.tabPosition]: _withId(() => [
        _createVNode("ol", {
          ref: "navs$",
          class: ["tab-navs", [_ctx.navClass]]
        }, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.navs, (nav, index) => {
            return (_openBlock(), _createBlock("li", {
              id: `${_ctx.tabId}_${index}`,
              class: [[_ctx.tabClass, { active: index === _ctx.activeIndex }], "tab-nav"],
              onClick: ($event: any) => (_ctx.switchTo(index)),
              key: index
            }, [
              (typeof nav === 'string')
                ? (_openBlock(), _createBlock("span", _hoisted_2, _toDisplayString(nav), 1))
                : (_openBlock(), _createBlock(_resolveDynamicComponent(nav), { key: 1 }))
            ], 10, ["id", "onClick"]))
          }), 128))
        ], 2)
      ]),
      default: _withId(() => [
        _createVNode("div", {
          ref: "el",
          class: ["tab-content", [_ctx.contentClass]],
          style: { width: _ctx.containerWidth, transform: `translate3d(${_ctx.offset}px, 0, 0)` },
          onTransitionend: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onSwiped && _ctx.onSwiped(...args)))
        }, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.panes, (content, index) => {
            return (_openBlock(), _createBlock(_KeepAlive, { key: index }, [
              (_ctx.activeIndex === index)
                ? (_openBlock(), _createBlock(_resolveDynamicComponent(content), {
                    key: 0,
                    navRef: `#${_ctx.tabId}_${index}`,
                    style: `width: ${_ctx.viewWidth}px;left:${index * _ctx.viewWidth}px`,
                    class: "tab-pane d-ib v-top p-r"
                  }, null, 8, ["navRef", "style"]))
                : _createCommentVNode("", true)
            ], 1024))
          }), 128))
        ], 38)
      ]),
      _: 2
    }, 1024)
  ]))
})